<div class="u-flex-row u-flex-align-items-center">
    <p>{{ 'NEW_VERSION' | translate }}</p>
    <button app-button [context]="uiContext.CoBrand" [appearance]="buttonAppearance.Link" (click)="reload()">
        {{ 'COMMON.RELOAD' | translate }}
    </button>
</div>
